import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import {
  getFormValues,
  getFormInitialValues,
  getFormSyncErrors,
  getFormMeta,
  getFormAsyncErrors,
  getFormSyncWarnings,
  getFormSubmitErrors,
  getFormError,
  isDirty,
  isPristine,
  isValid,
  isInvalid,
  isSubmitting,
  hasSubmitSucceeded,
  hasSubmitFailed,
  FormName,
  submit as submitAction,
  reset as resetAction,
} from 'redux-form';

function mapStateToProps(state, ownProps) {
  const { formName, ...restOwnProps } = ownProps;

  return {
    ...restOwnProps,
    form: {
      formName,
      dirty: isDirty(formName)(state),
      fields: getFormMeta(formName)(state),
      formAsyncErrors: getFormAsyncErrors(formName)(state),
      formError: getFormError(formName)(state),
      formSyncErrors: getFormSyncErrors(formName)(state),
      initialValues: getFormInitialValues(formName)(state),
      invalid: isInvalid(formName)(state),
      pristine: isPristine(formName)(state),
      submitErrors: getFormSubmitErrors(formName)(state),
      submitFailed: hasSubmitFailed(formName)(state),
      submitSucceeded: hasSubmitSucceeded(formName)(state),
      submitting: isSubmitting(formName)(state),
      syncWarnings: getFormSyncWarnings(formName)(state),
      valid: isValid(formName)(state),
      values: getFormValues(formName)(state),
    },
  };
}

const mapDispatchToProps = {
  submitForm: submitAction,
  resetForm: resetAction,
};

function mergeProps(stateProps, dispatchProps) {
  const { form, ...restStateProps } = stateProps;
  const { submitForm, resetForm } = dispatchProps;
  const { formName, ...restFormProps } = form;

  return {
    ...restStateProps,
    form: {
      ...restFormProps,
      handleReset: resetForm.bind(null, formName),
      handleSubmit: event => {
        event.preventDefault();
        return submitForm(formName);
      },
    },
  };
}

const withFormName = WrappedComponent => props =>
  <FormName>{({ form }) => <WrappedComponent {...props} formName={form} />}</FormName>;

export default compose(withFormName, connect(mapStateToProps, mapDispatchToProps, mergeProps));
